import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import backArrow from '../images/back-arrow.png'
import nextArrow from '../images/next-arrow.png'
import { RESPONSIVE_SCREEN_WIDTH_MEDIUM } from '../constants/GeneralConstants'

const ViewHeader = styled.div`
    color: ${props => props.theme.colors.lightGreenText};
    text-transform: uppercase;
    font-weight: 300;
    height: 100px !important;

    &.active {
        font-weight: bold;
    }
    word-break: break-word;
    text-align: center;

    &:focus {
        outline: none;
    }

`

const ViewRow = styled.div`
    flex: 1;
    margin-left: 0.5em;
    height: 100%;
`

const ButtonImage = styled.img`
    height: 70%;
    width: initial;
`

const ButtonImageWrapper = styled.div`
    max-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
`

const BackButton = styled.div`
    font-size: 30px;
    border: none;
    background-color: white;

    &:focus {
        outline: none;
    }

    &:disabled {
        ${ButtonImage} {
            visibility: hidden;
            pointer-events: none;
        }
    }
`

const NextButton = styled.div`
    font-size: 30px;
    border: none;
    background-color: white;

    &:focus {
        outline: none;
    }

    &:disabled {
        ${ButtonImage} {
            visibility: hidden;
            pointer-events: none;
        }
    }
`

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 3em;
    height: 100px;
`

const Wrapper = styled.div`
    width: 100%;
`

class ViewSlider extends React.Component {

    constructor(props) {
        super(props)
        this.state = { isMobile: false }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }
    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        this.setState({ isMobile: window.innerWidth < RESPONSIVE_SCREEN_WIDTH_MEDIUM })
    }

    setMobile = () => {
        if(window.innerWidth < RESPONSIVE_SCREEN_WIDTH_MEDIUM) {
            this.setState({ mobile: true })
        } else {
            this.setState({ mobile: false })
        }
    }

    render() {
        const {
            contentViews,
            setActiveView,
            activeView,
            nextView,
            previousView,
            addToIndex,
            id,
            hasErrorsInCurrentView,
            isPerson,
        } = this.props

        let indexAddition = addToIndex ? addToIndex : 0

        if (!contentViews) {
            return null
        }


        return (
            <Wrapper id={id}>
                <HeaderContainer>
                    {this.state.isMobile && activeView > 0 &&<BackButton>
                        <ButtonImageWrapper
                            onClick={!hasErrorsInCurrentView ? previousView : undefined}
                        >
                            <ButtonImage src={backArrow}/>
                        </ButtonImageWrapper>
                    </BackButton>}
                    <ViewRow>
                        <Container fluid={true}>
                            <Row>
                                {!this.state.isMobile && contentViews.map((item, index) =>
                                    <Col key={index}>
                                        <ViewHeader
                                            className={activeView === index + indexAddition ? 'active' : ''}
                                            onClick={() => setActiveView(index + indexAddition)}
                                            style={{
                                                display: 'inline-block',
                                                float: 'left',
                                                width: `${100 / contentViews.length }%`,
                                                pointerEvents: hasErrorsInCurrentView ? 'none' : 'auto',
                                                fontSize: isPerson ? '32px' : '',
                                                fontFamily: isPerson ? 'Roboto' : '',
                                            }}
                                        >
                                            {item.header}
                                        </ViewHeader>
                                    </Col>
                                )}
                                {this.state.isMobile &&
                                <Col><ViewHeader
                                    className={'active'}
                                    style={{
                                        fontSize: isPerson ? '32px' : '13px',
                                        fontFamily: isPerson ? 'Roboto' : '',
                                    }}
                                >
                                    {contentViews[activeView].header}
                                </ViewHeader></Col>
                                }
                            </Row>
                        </Container>
                    </ViewRow>
                    {this.state.isMobile && activeView < contentViews.length - 1 && <NextButton
                        onClick={!hasErrorsInCurrentView ? nextView : undefined}
                    >
                        <ButtonImageWrapper>
                            <ButtonImage src={nextArrow}></ButtonImage>
                        </ButtonImageWrapper>
                    </NextButton>}
                </HeaderContainer>
            </Wrapper>
        )
    }
}

ViewSlider.propTypes = {
    contentViews: PropTypes.array,
    setActiveView: PropTypes.func,
    activeView: PropTypes.number,
    nextView: PropTypes.func,
    previousView: PropTypes.func,
    addToIndex: PropTypes.number,
    id: PropTypes.string,
    theme: PropTypes.object,
    hasErrorsInCurrentView: PropTypes.bool,
    isPerson: PropTypes.bool,
}

export default ViewSlider
